import gql from 'graphql-tag';

import { assetFieldsFragment } from './utils';

export default gql`
  ${assetFieldsFragment}
  query getPublicAssets($status: String, $assetIds: [String]) {
    getPublicAssets(status: $status, assetIds: $assetIds ) {
      ...assetFields
    }
  }
`;